<template>
  <div class="profile-page">
    <!-- 头部用户信息区 -->
    <div class="profile-header">
      <!-- 左侧头像 -->
      <div class="avatar-section">
        <img :src="$store.state.LoginStorage.image" class="user-avatar" alt="avatar" />
      </div>

      <!-- 中间信息区 -->
      <div class="user-info">
        <!-- 用户名和IP -->
        <div class="user-name-row">
          <h2 class="user-name">{{ $store.state.LoginStorage.nickname }}</h2>
          <span class="user-meta"> ID {{ $store.state.LoginStorage.yhid }}</span>
        </div>

        <!-- 数据统计 -->
        <div class="user-stats">
          <div class="stat-item">
            <span class="stat-num">{{ $store.state.LoginStorage.zbid.length }}</span>
            <span class="stat-label">关注</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">0</span>
            <span class="stat-label">粉丝</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">{{ $store.state.LoginStorage.like.length || 0 }}</span>
            <span class="stat-label">赞</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-btns">
          <button class="edit-btn" @click="editProfile">编辑资料</button>
          <button class="upload-btn" @click="uploadContent">
            <i class="el-icon-upload2"></i>
            <span>上传</span>
          </button>
          
        </div>

        <!-- 个人简介 -->
        <div class="user-bio">
          <p class="bio-line">
            <!-- <span class="bio-icon">⏰</span> -->
            <span> {{ $store.state.LoginStorage.hangye }} ✨</span>
          </p>
        </div>
      </div>

      <!-- 右侧操作区 -->
      <div class="header-actions">
        <button class="share-btn" @click="shareProfile">
          <i class="el-icon-switch-button"></i>
          <span>退出</span>
        </button>
      </div>
    </div>

    <!-- 导航标签页 -->
    <div class="profile-tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab-item"
        :class="{ active: activeTab === index }"
        @click="switchTab(index)"
      >
        {{ tab.name }}
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="profile-content">
      <!-- 观看历史 -->
      <div v-if="activeTab === 0" class="history-section">
        <div v-if="historyList.length > 0" class="video-grid">
          <div v-for="(item, index) in historyList" :key="index" class="video-card" @click="playVideo(item)">
            <div class="video-cover" :style="{ background: item.cover }">
              <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
              <span class="video-viewers">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="video-info">
              <img :src="item.avatar" class="video-avatar" alt="avatar" />
              <span class="video-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-video-play"></i>
          <p>暂无作品</p>
        </div>
      </div>

      <!-- 关注 -->
      <div v-else-if="activeTab === 1" class="favorite-section">
        <div v-if="favoriteList.length > 0">
          <!-- 横向图片 -->
          <div class="video-grid">
            <div v-for="(item, index) in landscapeList" :key="'landscape-'+index" class="video-card" @click="playVideo(item)">
              <div class="video-cover">
                <img :src="item.cover.replace('url(', '').replace(')', '')" class="cover-img" alt="cover" @load="onImageLoad($event, item)" />
                <!-- 未开播时显示黑色遮罩 -->
                <div v-if="item.statuss === 0" class="offline-overlay"></div>
                <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
                <span class="video-viewers">
                  <i class="el-icon-user"></i>{{ item.viewers }}
                </span>
              </div>
              <div class="video-info">
                <img :src="item.avatar" class="video-avatar" alt="avatar" />
                <span class="video-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
          <!-- 竖向图片 -->
          <div class="video-grid portrait-grid">
            <div v-for="(item, index) in portraitList" :key="'portrait-'+index" class="video-card" @click="playVideo(item)">
              <div class="video-cover portrait">
                <img :src="item.cover.replace('url(', '').replace(')', '')" class="cover-img" alt="cover" @load="onImageLoad($event, item)" />
                <!-- 未开播时显示黑色遮罩 -->
                <div v-if="item.statuss === 0" class="offline-overlay"></div>
                <span class="video-tag" :class="item.tagType">{{ item.tag }}</span>
                <span class="video-viewers">
                  <i class="el-icon-user"></i>{{ item.viewers }}
                </span>
              </div>
              <div class="video-info">
                <img :src="item.avatar" class="video-avatar" alt="avatar" />
                <span class="video-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-star-off"></i>
          <p>暂无关注内容</p>
        </div>
      </div>

      <!-- 赞过 -->
      <div v-else-if="activeTab === 2" class="liked-section">
        <div v-if="likedList.length > 0">
          <!-- 横向图片 -->
          <div class="video-grid">
            <div v-for="(item, index) in likedLandscapeList" :key="'liked-landscape-'+index" class="video-card" @click="huifang(item.id)">
              <div class="video-cover">
                <img :src="item.cover.replace('url(', '').replace(')', '')" class="cover-img" alt="cover" @load="onImageLoad($event, item)" />
                <span class="video-tag replay">回放</span>
              </div>
              <div class="video-info">
                <img :src="item.avatar" class="video-avatar" alt="avatar" />
                <span class="video-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
          <!-- 竖向图片 -->
          <div class="video-grid portrait-grid">
            <div v-for="(item, index) in likedPortraitList" :key="'liked-portrait-'+index" class="video-card" @click="huifang(item.id)">
              <div class="video-cover portrait">
                <img :src="item.cover.replace('url(', '').replace(')', '')" class="cover-img" alt="cover" @load="onImageLoad($event, item)" />
                <span class="video-tag replay">回放</span>
              </div>
              <div class="video-info">
                <img :src="item.avatar" class="video-avatar" alt="avatar" />
                <span class="video-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-thumb"></i>
          <p>暂无赞过的内容</p>
        </div>
      </div>

      <!-- 钱包 -->
      <div v-else-if="activeTab === 3" class="wallet-section">
        <!-- 余额卡片 -->
        <div class="wallet-balance-card">
          <div class="balance-header">
            <div class="balance-icon">
              <i class="el-icon-wallet"></i>
            </div>
            <span class="balance-title">我的余额</span>
          </div>
          <div class="balance-content">
            <div class="balance-amount">
              <span class="amount-num">{{ $store.state.LoginStorage.coin || 0 }}</span>
              <span class="amount-unit">甜筒</span>
            </div>
            <button class="recharge-btn" @click="recharge">
              <i class="el-icon-plus"></i>
              充值
            </button>
          </div>
        </div>

        <!-- 账户信息卡片 -->
        <div class="wallet-info-card">
          <h4 class="info-title">
            <i class="el-icon-user"></i>
            账户信息
          </h4>
          <div class="info-list">
            <div class="info-item">
              <span class="info-label">账号</span>
              <span class="info-value">{{ $store.state.LoginStorage.username }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">昵称</span>
              <span class="info-value">{{ $store.state.LoginStorage.nickname }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">用户ID</span>
              <span class="info-value">{{ $store.state.LoginStorage.yhid }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">手机号</span>
              <span class="info-value">{{ $store.state.LoginStorage.phone }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">年龄</span>
              <span class="info-value">{{ $store.state.LoginStorage.age }} 岁</span>
            </div>
            <div class="info-item">
              <span class="info-label">性别</span>
              <span class="info-value">{{ $store.state.LoginStorage.gender }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">生日</span>
              <span class="info-value">{{ $store.state.LoginStorage.birthday }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">甜筒余额</span>
              <span class="info-value vip-level">{{ $store.state.LoginStorage.coin || 0 }}</span>
            </div>
          </div>
        </div>

        <!-- 消费记录（送礼记录） -->
        <div class="wallet-records">
          <h4 class="records-title">
            <i class="el-icon-present"></i>
            送礼记录
          </h4>
          <div v-if="giftRecords.length > 0" class="wallet-gift-list">
            <div v-for="(gift, index) in giftRecords" :key="index" class="wallet-gift-item">
              <!-- 礼物图片 -->
              <div class="wallet-gift-left">
                <div class="wallet-gift-icon">
                  <img :src="gift.image" alt="gift" />
                </div>
                <div class="wallet-gift-info">
                  <span class="wallet-gift-name">{{ gift.name }}</span>
                  <span class="wallet-gift-anchor">送给 {{ gift.anchor_name }}</span>
                </div>
              </div>
              <!-- 数量和金额 -->
              <div class="wallet-gift-right">
                <span class="wallet-gift-num">x{{ 1}}</span>
                <span class="wallet-gift-total">-{{ gift.number }} 甜筒</span>
              </div>
            </div>
          </div>
          <div v-else class="records-empty">
            <i class="el-icon-present"></i>
            <span>暂无送礼记录</span>
          </div>
        </div>
      </div>

      <!-- 礼物 -->
      <div v-else-if="activeTab === 4" class="gift-section">
        <div v-if="giftRecords.length > 0" class="gift-list">
          <div v-for="(gift, index) in giftRecords" :key="index" class="gift-item">
            <!-- 礼物图片 -->
            <div class="gift-left">
              <div class="gift-icon">
                <img :src="gift.image" alt="gift" />
              </div>
              <div class="gift-info">
                <span class="gift-name">{{ gift.name }}</span>
                <span class="gift-price">{{ gift.jine }} 甜筒/个</span>
              </div>
            </div>
            <!-- 送礼信息 -->
            <div class="gift-middle">
              <div class="gift-anchor">
                <i class="el-icon-user"></i>
                <span>送给：{{ gift.anchor_name }}</span>
              </div>
              <span class="gift-time">房间号：{{ gift.zhuboid }}</span>
            </div>
            <!-- 数量 -->
            <div class="gift-right">
              <span class="gift-num">x{{ 1 }}</span>
              <span class="gift-total">共 {{gift.number }} 甜筒</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-present"></i>
          <p>暂无礼物记录</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProfilePage',
  data() {
    return {
      // 用户信息
      // 标签页
      tabs: [
        { name: '我的作品', id: 'history' },
        { name: '关注', id: 'favorite' },
        { name: '赞过', id: 'liked' },
        // { name: '钱包', id: 'wallet' },
        { name: '礼物', id: 'gift' }
      ],
      // 当前选中标签
      activeTab: 0,
      // 我的作品 - 默认为空
      historyList: [],
      // 收藏列表
      favoriteList: [],
      // 赞过列表
      likedList: [],
      // 消费记录
      consumeRecords: [],
      // 送礼记录
      giftRecords: []
    }
  },
  computed: {
    // 关注列表 - 横向图片
    landscapeList() {
      return this.favoriteList.filter(item => !item.isPortrait)
    },
    // 关注列表 - 竖向图片
    portraitList() {
      return this.favoriteList.filter(item => item.isPortrait)
    },
    // 赞过列表 - 横向图片
    likedLandscapeList() {
      return this.likedList.filter(item => !item.isPortrait)
    },
    // 赞过列表 - 竖向图片
    likedPortraitList() {
      return this.likedList.filter(item => item.isPortrait)
    }
  },
  mounted() {
    // 请求送礼记录
    axios.get('https://ttxq.xiangyouhulian.cn/api/index/slwlist',{
      params:{
        yhid:this.$store.state.LoginStorage.id
      }
    })
      .then(response => {
        this.giftRecords = response.data.data;
        console.log('Gift records fetched:', response.data.data);
      })
      .catch(error => {
        console.error('Error fetching history:', error);
      });
    
    // 请求关注列表
    this.fetchFollowList()
    // 请求点赞列表
    this.fetchLikeList()
  },
  methods: {
    // 编辑资料
    editProfile() {
      this.$router.push('/shezhi');
    },
    // 退出登录
    shareProfile() {
      // 弹出确认框
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除本地存储
        localStorage.removeItem('TTxq')
        // 清空 Vuex
        this.$store.commit('LoginModification', -1)
        // 跳转到首页
        this.$router.push('/')
        this.$message.success('已退出登录')
      }).catch(() => {
        // 取消退出
      })
    },
    // 上传内容
    uploadContent() {
      this.$router.push('/scsp');
    },
    // 显示菜单
    showMenu() {
      this.$emit('showMenu')
    },
    // 切换标签
    switchTab(index) {
      this.activeTab = index
    },
    // 播放视频
    playVideo(item) {
      console.log(item.anchorid,item.id)
      this.$router.push(`/zb/${item.anchorid}/${item.id}`);
    },
    huifang(id) {
      this.$router.push(`/hf/${id}/${10}`);
    },
    // 图片加载完成后判断比例
    onImageLoad(event, item) {
      const img = event.target
      const width = img.naturalWidth
      const height = img.naturalHeight
      // 如果高度大于宽度，认为是竖向图片
      this.$set(item, 'isPortrait', height > width)
    },
    // 充值 - 打开充值弹窗
    recharge() {
      this.$store.commit('setVipshow', true)
    },
    // 获取关注列表
    fetchFollowList() {
      const userId = this.$store.state.LoginStorage.id
      if (!userId) {
        console.log('用户未登录，无法获取关注列表')
        return
      }
      
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/guanzhu', {
        params: {
          yhid: userId
        }
      }).then(response => {
        console.log('关注列表接口返回:', response.data)
        if (response.data.code === 1 && response.data.data) {
          // 转换数据格式适配页面展示
          this.favoriteList = response.data.data.map(item => ({
            id: item.id,
            anchorid:item.anchorid,
            name: item.anchor_name,
            avatar: item.touxiang,
            cover: `url(${item.image})`,  // 背景图需要url()包裹
            viewers: item.anchor_number,
            statuss: item.statuss,  // 保存状态用于判断
            tag: item.statuss == 1 ? '直播中' : (item.statuss == 0 ? '待开播' : '回放'),
            tagType: item.statuss == 1 ? 'live' : (item.statuss == 0 ? 'offline' : 'replay'),
            rawData: item  // 保留原始数据
          }))
        }
      }).catch(error => {
        console.error('获取关注列表失败:', error)
      })
    },
    // 获取点赞列表
    fetchLikeList() {
      const userId = this.$store.state.LoginStorage.id
      if (!userId) {
        console.log('用户未登录，无法获取点赞列表')
        return
      }
      
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/likes', {
        params: {
          yhid: userId
        }
      }).then(response => {
        console.log('点赞列表接口返回:', response.data)
        if (response.data.code === 1 && response.data.data) {
          // 转换数据格式适配页面展示
          this.likedList = response.data.data.map(item => ({
            id: item.id,
            anchorid:item.anchorid,
            name: item.anchor_name,
            avatar: item.touxiang,
            cover: `url(${item.hfimage})`,  // 背景图需要url()包裹
            viewers: item.anchor_number,
            paixu: item.paixu || 1,  // 保存排序字段
            rawData: item  // 保留原始数据
          }))
        }
      }).catch(error => {
        console.error('获取点赞列表失败:', error)
      })
    }
  }
}
</script>

<style scoped lang="scss">
// 页面主容器
.profile-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, hsl(0, 0%, 100%) 100%);
  padding: 40px 48px;
}

// 头部用户信息区
.profile-header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 32px;
}

// 头像区域
.avatar-section {
  flex-shrink: 0;
}

.user-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

// 用户信息区
.user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 用户名行
.user-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.user-meta {
  font-size: 13px;
  color: #999;
}

// 数据统计
.user-stats {
  display: flex;
  gap: 24px;
}

.stat-item {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.stat-num {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

// 操作按钮
.action-btns {
  display: flex;
  gap: 12px;
}

.edit-btn {
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #ff4d4f;
  border: none;
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #ff7875;
    box-shadow: 0 2px 8px rgba(255, 77, 79, 0.3);
  }

  i {
    font-size: 14px;
  }
}

// 个人简介
.user-bio {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bio-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.bio-icon {
  font-size: 14px;
}

// 头部右侧操作
.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.upload-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  i {
    font-size: 14px;
  }
}

.menu-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  cursor: pointer;
  color: #999;
  font-size: 18px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    color: #666;
  }
}

// 导航标签页
.profile-tabs {
  display: flex;
  gap: 48px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.tab-item {
  font-size: 15px;
  color: #666;
  cursor: pointer;
  padding: 8px 0;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    color: #8a3ffc;
  }

  &.active {
    color: #8a3ffc;
    font-weight: 500;

    &::after {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 2px;
      background: #8a3ffc;
      border-radius: 1px;
    }
  }
}

// 内容区域
.profile-content {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 16px;
  padding: 24px;
  min-height: 400px;
}

// 空内容
.empty-content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #999;
  font-size: 14px;
}

// 视频网格
.video-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom:30px;
}

.video-card {
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }
}

.video-cover {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10; // 默认横向比例
  border-radius: 12px;
  overflow: hidden;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;

  // 竖向图片使用 3:4 比例
  &.portrait {
    aspect-ratio: 3 / 4;
  }

  .cover-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; // 占满容器，保持比例
    z-index: 1;
  }
}

// 未开播遮罩层
.offline-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
}

.video-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 10px;
  border-radius: 16px;
  font-size: 13px;
  color: #fff;
  z-index: 3;
  padding-bottom: 3px;

  &.live {
    background: #FF6B9D;
  }

  &.replay {
    background: #8B5CF6;
  }

  &.offline {
    background: #F5A623;  // 黄色背景
  }
}

.video-viewers {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  padding: 2px 8px;
  border-radius: 12px;
  z-index: 3;
}

.video-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.video-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.video-name {
  font-size: 16px;
  color: #333;
}

// 空状态
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #999;

  i {
    font-size: 48px;
    margin-bottom: 16px;
    color: #ccc;
  }

  p {
    font-size: 14px;
  }
}

// 钱包区域
.wallet-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

// 余额卡片
.wallet-balance-card {
  background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
  border-radius: 16px;
  padding: 28px 32px;
  color: #fff;
  box-shadow: 0 8px 24px rgba(138, 63, 252, 0.25);
}

.balance-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  opacity: 0.9;
}

.balance-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;

  i {
    font-size: 20px;
  }
}

.balance-title {
  font-size: 16px;
  font-weight: 500;
}

.balance-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.balance-amount {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.amount-num {
  font-size: 48px;
  font-weight: 700;
  line-height: 1;
}

.amount-unit {
  font-size: 16px;
  opacity: 0.8;
}

.recharge-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 24px;
  background: #fff;
  border: none;
  border-radius: 24px;
  color: #8A3FFC;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  i {
    font-size: 14px;
  }
}

// 账户信息卡片
.wallet-info-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.info-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #181426;
  margin: 0 0 20px 0;

  i {
    font-size: 18px;
    color: #8A3FFC;
  }
}

.info-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #F9F7FF;
  border-radius: 10px;
}

.info-label {
  font-size: 13px;
  color: #9B8DC7;
}

.info-value {
  font-size: 14px;
  color: #4B3B73;
  font-weight: 500;

  &.vip-level {
    color: #FF6B6B;
    font-weight: 600;
  }
}

// 消费记录
.wallet-records {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.records-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #181426;
  margin: 0 0 20px 0;

  i {
    font-size: 18px;
    color: #8A3FFC;
  }
}

.records-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #9B8DC7;

  i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #E5E7EB;
  }

  span {
    font-size: 14px;
  }
}

// 钱包送礼记录列表
.wallet-gift-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wallet-gift-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: #F9F7FF;
  border-radius: 12px;
  transition: all 0.3s ease;

  &:hover {
    background: #ECE6FF;
    transform: translateX(4px);
  }
}

.wallet-gift-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.wallet-gift-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fff 0%, #f5f5f5 100%);
  border-radius: 10px;
  padding: 6px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.wallet-gift-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wallet-gift-name {
  font-size: 14px;
  font-weight: 600;
  color: #181426;
}

.wallet-gift-anchor {
  font-size: 12px;
  color: #9B8DC7;
}

.wallet-gift-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.wallet-gift-num {
  font-size: 14px;
  font-weight: 600;
  color: #4B3B73;
}

.wallet-gift-total {
  font-size: 13px;
  font-weight: 600;
  color: #FF6B6B;
}

// 礼物区域
.gift-section {
  .gift-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .gift-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(138, 63, 252, 0.1);
      transform: translateY(-2px);
    }
  }

  // 左侧：礼物图片和信息
  .gift-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
  }

  .gift-icon {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f9f7ff 0%, #ece6ff 100%);
    border-radius: 12px;
    padding: 8px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .gift-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .gift-name {
    font-size: 15px;
    font-weight: 600;
    color: #181426;
  }

  .gift-price {
    font-size: 13px;
    color: #8a3ffc;
    font-weight: 500;
  }

  // 中间：送礼对象信息
  .gift-middle {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
    min-width: 140px;
  }

  .gift-anchor {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #4b3b73;

    i {
      font-size: 14px;
      color: #8a3ffc;
    }
  }

  .gift-time {
    font-size: 12px;
    color: #9b8dc7;
  }

  // 右侧：数量和总价
  .gift-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    min-width: 100px;
  }

  .gift-num {
    font-size: 18px;
    font-weight: 600;
    color: #ff6b6b;
  }

  .gift-total {
    font-size: 13px;
    color: #9b8dc7;
  }
}
</style>